import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize} from '../../shared/theme/helpers';

export default () =>
  useStyles(({isDesktop, theme, mediaOnly}) => {
    return {
      con: {
        display: 'flex',
        flexDirection: 'column',
      },
      text: {
        ...theme.fonts.h5Light,
        color: theme.color.mainPageTextNameColor,
      },
      engine: {
        position: 'absolute',
        right: 0,
      },
      sectionContainer: {
        marginTop: 58,
        paddingHorizontal: 24,
        paddingBottom: 112,
      },
      gradientContainer: {
        position: 'relative',
      },
      gradientHead: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '30%',
      },
      container: {
        paddingTop: 32,
        paddingBottom: isDesktop ? 10 : 7,
      },
      newsContainer: {
        ...mediaOnly(
          DeviceSize.desktop,
          {
            paddingTop: 63,
            paddingBottom: 112,
          },
          {
            paddingTop: 29,
            paddingBottom: 8,
            paddingHorizontal: 0,
          },
        ),
      },
      titleContainerDesktop: {...theme.fonts.h2, marginBottom: 24},
      titleContainerMobile: {...theme.fonts.h6, marginBottom: 26, textAlign: 'center'},
    };
  });
